<template>
  <select v-if="options" v-model="checkValue">
    <option v-for="opt in options" :key="opt.value" :value="opt.value">{{opt.label}}</option>
  </select>
</template>
<script lang="ts">
import { computed, defineComponent, toRefs } from "vue";

export default defineComponent({
  name: "SelectBoxRenderer",
  setup(props: any) {
    const { params } = toRefs(props);
    const options = computed(() => params.value.options);
    const checkValue = computed({
      get: () => params.value.value,
      set: (v) => {
        params.value.node.setDataValue(params.value.column.colId, v);
      },
    });

    return {
      checkValue,
      options,
    };
  },
});
</script>
